import React from 'react'
import cx from 'classnames'
import { LKIcon } from 'loankeeper-common/components'

import {
  CheckboxField,
  DatePickerField,
  MultiCheckboxField,
  RadioField,
  SelectField,
  TextAreaField,
  TextField,
  NumberField,
  RangeDatePicker,
  DecoratedRangePickerFirstField,
  SelectFieldWithAdditions,
  FloatField,
} from './Fields'

import types from './fieldTypes'

const CustomErrorComponent = ({ error }) => {
  if (typeof error === 'object' && Object.prototype.hasOwnProperty.call(error, 'allErrors')) {
    return (
      <>
        <LKIcon alias="info" style={{ marginBottom: 5 }} />
        {error.allErrors.map((current) => (
          <p key={current} style={{ marginBottom: 2 }}>
            {current}
          </p>
        ))}
      </>
    )
  }

  return error || null
}

const FormField = ({ visible, GetError, className, ...rest }) => {
  if (!visible) {
    // For FormLayout component
    return <span />
  }

  const enhancedClassName = cx(className, 'lk-form-field')

  switch (rest.type) {
    case types.checkbox:
      return <CheckboxField {...rest} className={enhancedClassName} />
    case types.number:
      return <NumberField {...rest} className={enhancedClassName} GetError={GetError || CustomErrorComponent} />
    case types.float:
      return <FloatField {...rest} className={enhancedClassName} GetError={GetError || CustomErrorComponent} />
    case types.date:
      return <DatePickerField {...rest} className={enhancedClassName} />
    case types.multicheckbox:
      return <MultiCheckboxField {...rest} className={enhancedClassName} />
    case types.radio:
      return <RadioField {...rest} className={enhancedClassName} />
    case types.select:
      return <SelectField {...rest} className={enhancedClassName} />
    case types.textarea:
      return <TextAreaField {...rest} className={enhancedClassName} />
    case types.rangeDatePicker:
      return <RangeDatePicker {...rest} className={enhancedClassName} />
    case types.rangeDatePickerFirstInput:
      return <DecoratedRangePickerFirstField {...rest} className={enhancedClassName} />
    case types.selectFieldWithAdditions:
      return <SelectFieldWithAdditions {...rest} className={enhancedClassName} />
    case types.password:
      return <TextField type="password" {...rest} className={enhancedClassName} />
    default:
      return <TextField {...rest} className={enhancedClassName} />
  }
}

FormField.defaultProps = {
  visible: true,
}

export default FormField
